import React from "react";
import { withProtectedRoute } from "../../components/ProtectedRoute";
import { withParams } from "../../hoc/navigation/withParams";
import { Params } from "react-router-dom";
import { InstallerPageComponent } from "../installer";

interface IOwnProps {
    jobId: string;
}

type Props = IOwnProps & Readonly<Params<string>>;

export class JobMediaManagementPageComponent extends React.PureComponent<Props> {
    render() {
        return <InstallerPageComponent jobId={this.props.jobId} isNonInstaller={true} />;
    }
}

export const JobMediaManagementPage = withProtectedRoute(withParams(JobMediaManagementPageComponent));
